/**
 * @generated SignedSource<<8a3b7b691b9773ef93b32b66f4bf5ae9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectGroupPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectGroupPermissionsSettingsAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupPermissionsSettings">;
};
export type ProjectGroupPermissionsSettingsAggQuery = {
  response: ProjectGroupPermissionsSettingsAggQuery$data;
  variables: ProjectGroupPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "TownsquareGroupConnection",
                "kind": "LinkedField",
                "name": "projects_groups_extension",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDefaultGroup"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "userCount"
                          },
                          {
                            "concreteType": "ProductRole",
                            "kind": "LinkedField",
                            "name": "productRoles",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "role"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGroupAppPermission",
                            "kind": "LinkedField",
                            "name": "appPermissions",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isPermitted"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1e7104914564ac902a486a36a2eb97c7",
    "id": null,
    "metadata": {},
    "name": "ProjectGroupPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b747ebfcd43814c58ef4222a19dfc62d";

export default node;
